export default {
  title: "Notes",
  edit_note: "Edit Note",
  edit: "Edit",
  placeholder_text: "No notes added yet",
};
